/**
 * Mobile sticky purchase bar of the THCC product page (`blocks/thcc-pdp-barra.liquid`).
 *
 * The bar never re-implements the purchase flow: "Agregar" clicks the page's real add-to-cart button and
 * "Comprar ahora" clicks the real dynamic checkout button, so Horizon's cart drawer, counters and
 * analytics keep working. On mobile it is visible from page load whenever the main buy buttons are off screen
 * (still below the fold, or already scrolled past) and slides away while they are in view.
 */

const MOBILE = window.matchMedia('(max-width: 749px)');

/** @returns {HTMLElement | null} */
function mainButtons() {
  const el = document.querySelector('.product-details .product-form-buttons');
  return el instanceof HTMLElement ? el : null;
}

/** @returns {HTMLButtonElement | null} */
function realAddButton() {
  const el = document.querySelector('.product-details .add-to-cart-button');
  return el instanceof HTMLButtonElement ? el : null;
}

/** @returns {HTMLElement | null} */
function realBuyNow() {
  const el = document.querySelector('.product-details .shopify-payment-button__button');
  return el instanceof HTMLElement ? el : null;
}

/** @param {HTMLElement} bar */
function sync(bar) {
  const add = realAddButton();
  const disabled = !add || add.disabled;
  for (const button of bar.querySelectorAll('button')) button.disabled = disabled;
}

/** @param {HTMLElement} bar */
function init(bar) {
  if (bar.dataset.listo === 'true') return;
  bar.dataset.listo = 'true';

  bar.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('button[data-accion]') : null;
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    if (button.dataset.accion === 'agregar') {
      realAddButton()?.click();
    } else if (button.dataset.accion === 'comprar') {
      (realBuyNow() ?? realAddButton())?.click();
    }
  });

  const target = mainButtons();
  if (target && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry) return;
        // Visible whenever the buttons are off screen: below the fold at load, or already scrolled past.
        bar.classList.toggle('is-visible', MOBILE.matches && !entry.isIntersecting);
      },
      { threshold: 0 }
    );
    observer.observe(target);
  }

  const add = realAddButton();
  if (add) new MutationObserver(() => sync(bar)).observe(add, { attributes: true, attributeFilter: ['disabled'] });
  sync(bar);
}

function run() {
  for (const bar of document.querySelectorAll('[data-thcc-barra]')) {
    if (bar instanceof HTMLElement) init(bar);
  }
}

document.addEventListener('shopify:section:load', run);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', run, { once: true });
} else {
  run();
}
